// extracted by mini-css-extract-plugin
export default {"content":"RecoveryDialog__content--39N4_"};